import InteractionEvent, {
  type InteractionTargetType
} from './InteractionEvent';

export type FilterSelection = { key: string; value: string };

export type FilterPlacement = 'facet_nav';

export type FilterTargetProperties = {
  filters?: { key: string; value: string }[];
  placement: FilterPlacement;
  selected_filters: FilterSelection[];
  sort_key: string;
};

type EventData = {
  filters?: { key: string; value: string }[];
  gesture?: string;
  guestId?: string;
  isBot: boolean;
  placement: FilterPlacement;
  selectedFilters: FilterSelection[];
  sortKey: string;
};

class FilterInteractionEvent extends InteractionEvent<
  EventData,
  FilterTargetProperties
> {
  protected get targetType(): InteractionTargetType {
    return 'filter';
  }

  protected getTargetProperties(): FilterTargetProperties {
    return {
      filters: this.data.filters,
      placement: this.data.placement,
      selected_filters: this.data.selectedFilters,
      sort_key: this.data.sortKey
    };
  }
}

export default FilterInteractionEvent;
